module.exports = {"bewizr-agenda":{"empty":{"title":"Нет мероприятий","detail":"У вас нет запланированных мероприятий."}}}